import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import { getCardIconSrc, getCvvIconSrc } from './get-icon-src';

const path = `https://${FRAME_LIBRARY_URL}/vgs-collect/icons`;

export default function Icon(props) {
  const { type, styles, card, icons } = props;
  let src = '';

  if (type === 'card-icon') {
    src = getCardIconSrc(card, icons);
  }

  if (type === 'cvv-icon') {
    src = getCvvIconSrc(card, icons);
  }

  return (
    <img
      src={src}
      alt="Card Icon"
      className={`icon ${css`
        ${styles}
      `} ${card} ${type}`}
    />
  );
}

Icon.propTypes = {
  styles: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.bool]),
  type: PropTypes.string,
  card: PropTypes.string,
};
